module.exports = __webpack_public_path__ + "static/media/renault-logo.8cbce347.png";